import * as defaultImport from "@splunk/react-icons/ControlPlayResume";
export * from "@splunk/react-icons/ControlPlayResume";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
